<template>
  <div class="ads-list-overlay">
    <transition name="fade">
      <div v-if="overlayType > 0" class="overlay-container">
        <div class="overlay-message">
          <svg class="sad-face" viewBox="0 0 42 42">
            <use xlink:href="#sad-face"></use>
          </svg>
          <span class="message-content"> {{overlayContent}}</span>
          <svg class="cry-face" viewBox="0 0 47 47">
            <use xlink:href="#cry-face"></use>
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      isEmailType: Boolean,
      overlayType: Number,
      smsSend: Boolean,
    },

    name: 'AdsListOverlay',

    computed: {
      overlayContent: function () {
        switch (this.overlayType) {
          case 1:
            return 'no sponsored images'
          case 3:
            return 'only available on sms'
          default:
            return null
        }
      },
    },
  }
</script>
